<template>
   <blank-layout>
      <div class="flex justify-center items-center bg-teal-800 h-full">
         <v-card width="500" max-height="200" class="">
            <v-card-title>{{ (nomtype === 'proposer') ? 'Proposer' : 'Seconder' }} Consent</v-card-title>
            <v-card-text>
               I, hereby propose that {{ (originator) ? originator.name : '' }} is to be accepted into MIP as a member.
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="black" >
                  <span class="text-white" @click="updatedeclaration">I Agree</span>
               </v-btn>
               <v-spacer></v-spacer>
            </v-card-actions>
         </v-card>
      </div>
   </blank-layout>
</template>

<script>
const axios = require('axios')
import BlankLayout from '../Layouts/BlankLayout.vue'

export default {
   name: 'MOMConsent',
   props: [ 'user', 'originator', 'nomtype' ],
   components: {
      BlankLayout,
   },
   data: () => ({
      og: null,
   }),
   methods: {
      updatedeclaration() {
         var targetPath = ''
         if (this.nomtype === 'proposer') {
            targetPath = '/member/decl/consent/proposer'
         } else {
            targetPath = '/member/decl/consent/seconder'
         }

         var data = {
            userid: this.originator.id
         }
         axios.post(targetPath, data)
         .then((resp) => {
            if (resp.data) {
               var rtn = resp.data
               if (rtn.status === 'OK') {
                  this.logout()
               }
            }
         })
      },

      logout() {
         axios.post(route('logout').url()).then(response => {
            window.location = (response.data && response.data.redirect) ? response.data.redirect : '/';
         })
      }
   },
   mounted: function () {
      this.og = this.ogriginator
      console.log(this.og)
   },
}
</script>
